"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationSuccessResult = void 0;
exports.EvaluationSuccessResult = {
    Success: "success",
    Failure: "failure",
    Unknown: "unknown",
};
